<div *ngIf="this.loaderService.getLoading()" class="vertical-centered-box">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
</div>